import script from "./h5.vue?vue&type=script&setup=true&lang=js"
export * from "./h5.vue?vue&type=script&setup=true&lang=js"

import "./h5.vue?vue&type=style&index=0&id=63fe4a40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fe4a40"]])

export default __exports__